import { accountCreatedGetters } from './routines'

export default {
  [accountCreatedGetters.ACCOUNT_CREATED]: state => state.accountCreated
}
